import { FiBookOpen, FiCalendar, FiDollarSign, FiUsers } from 'react-icons/fi'
import { NumberIcon } from '../../components/widgets'
import { TfiWallet } from "react-icons/tfi";
import { Calendar } from '../course/calendar';
import { Messages } from '../../components/chat';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getDashboardStat } from '../../store/profile/profileActions';
import { getWalletStats } from '../../store/wallet/walletActions';

const DashboardTutor = () => {
    const {balance, income} = useSelector(state => state.wallet)

    const dispatch= useDispatch();

    useEffect(() => {
        dispatch(getDashboardStat())
        dispatch(getWalletStats())
    }, [])

    const {stats} = useSelector(state => state.profile)    
    return (
        <>
            <div className="general-informations mb-5 grid 2xl:grid-cols-5 sm:grid-cols-2 gap-4">
                <NumberIcon title="Students" number={stats.students} Icon={FiUsers} />
                <NumberIcon title="Lessons" number={stats.lessons} Icon={FiBookOpen} />
                <NumberIcon title="Attendance" number={stats.attendance + "%"} Icon={FiCalendar} />
                <NumberIcon title="Total Income" number={income + " €"} Icon={FiDollarSign} />
                <NumberIcon className='2xl:col-span-1 sm:col-span-2' title="Balance" number={balance + " €"} Icon={TfiWallet} />
            </div>
            <div className="grid lg:grid-cols-6 gap-4">
                <div className="grid col-span-1 lg:col-span-4 bg-white p-5 rounded-xl">
                    <h2 className='text-nt-blue max-h-[50px]'>Courses</h2>
                    <Calendar />
                </div>
                <div className="flex-col col-span-1 lg:col-span-2 bg-white p-5 flex items-start justify-start rounded-xl">
                    <h2 className='text-nt-blue max-h-[50px]'>Chat</h2>
                    <Messages getMessage={true} search={false} />
                </div>
            </div>
        </>
    )
}

export { DashboardTutor }